import { Navigate } from "react-router-dom"
import { useAdministrationRedirectTarget } from "../../hooks/useAdministrationRedirectTarget"

export const OrganizationRedirect = () => {
  const target = useAdministrationRedirectTarget()

  return (
    <Navigate
      to={target}
      replace
    />
  )
}
